import { connect } from 'react-redux';
import { get } from 'lodash-es';
import Player from '../components/Player';
import { isPlaying } from '../selectors/player';
import { areInitialScreensPreloaded } from '../selectors/screen';
import { areHotspotsLoaded } from '../selectors/hotspot';
import { isInHandoffMode } from '../selectors/handoff';
var mapStateToProps = function (state) { return ({
    isInHandoffMode: isInHandoffMode(state),
    isPlaying: isPlaying(state),
    areInitialScreensPreloaded: areInitialScreensPreloaded(state),
    areHotspotsLoaded: areHotspotsLoaded(state),
    transition: state.screen.transition,
    backgroundColor: state.project.config.screenBackgroundColour,
    isEmpty: get(state, 'project.config.screens.length') === 0,
}); };
export default connect(mapStateToProps, null)(Player);
